import { globalState } from '@/components/helpers/utils'

const getFilterDisplayCustomisations = (field) => {
  const filterMetaobject = globalState.metaobjects?.filters || []
  const relevantFilter = filterMetaobject.find((filter) => filter.searchspring_field === field)
  return relevantFilter || {}
}

const ColorSwatch = ({ color }) => (
    <div
      className="size-1.5 mr-0.5 border rounded-full border-neutral-light"
      style={{ backgroundColor: color }}
    />
)

const IconImage = ({ iconObject, width = 24, className = '' }) => {
  if (!iconObject) return null
  return (
      <svg
          width={width}
          height={width / iconObject.aspectRatio}
          className={className}
          xmlns="http://www.w3.org/2000/svg"
        >
          <use
            href={iconObject.icon + '#' + iconObject.iconID}
            width={width}
            height={width / iconObject.aspectRatio}
            preserveAspectRatio="xMidYMid meet"
          />
      </svg>
  )
}

export { getFilterDisplayCustomisations, ColorSwatch, IconImage }
